import _Object$keys from 'babel-runtime/core-js/object/keys';

import { filedGetFieldAPI } from '@/api/crm/common';
import { crmInvoiceSaveAPI, crmInvoiceUpdateAPI } from '@/api/crm/invoice';
import { crmCustomerInvoiceInfoAPI } from '@/api/crm/customer';

import XrCreate from '@/components/XrCreate';
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems';
import CreateSections from '@/components/CreateSections';
import CreateExamineInfo from '@/components/Examine/CreateExamineInfo';

import CustomFieldsMixin from '@/mixins/CustomFields';
import { objDeepCopy } from '@/utils';

import { XhInput, XhTextarea, XhSelect, XhDate, XhReceivablesPlan, CrmRelativeCell } from '@/components/CreateCom';
import CrmRelative from '@/components/CreateCom/CrmRelative';

export default {
  // 订单创建
  name: 'InvoiceCreate',
  components: {
    XrCreate: XrCreate,
    CreateSections: CreateSections,
    CreateExamineInfo: CreateExamineInfo,
    XhInput: XhInput,
    XhReceivablesPlan: XhReceivablesPlan,
    XhTextarea: XhTextarea,
    XhSelect: XhSelect,
    XhDate: XhDate,
    CrmRelativeCell: CrmRelativeCell,
    CrmRelative: CrmRelative,
    WkFormItems: WkFormItems
  },
  filters: {
    /** 根据type 找到组件 */
    typeToComponent: function typeToComponent(form_type) {
      if (form_type == 'text' || form_type == 'floatnumber') {
        return 'XhInput';
      } else if (form_type == 'select') {
        return 'XhSelect';
      } else if (form_type == 'contract' || form_type == 'customer') {
        return 'CrmRelativeCell';
      } else if (form_type == 'date') {
        return 'XhDate';
      } else if (form_type == 'textarea') {
        return 'XhTextarea';
      }
    }
  },
  mixins: [CustomFieldsMixin],
  props: {
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'save',
          id: '',
          data: {}
        };
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      invoiceTypeOptions: [{
        name: '增值税专用发票',
        value: 1
      }, {
        name: '增值税普通发票',
        value: 2
      }, {
        name: '国税通用机打发票',
        value: 3
      }, {
        name: '地税通用机打发票',
        value: 4
      }, {
        name: '收据',
        value: 5
      }],
      ignoreFields: ['invoice_type'],
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {},
      showPopover: false,
      titleAction: {
        type: 'default'
      },
      showSelectView: false,
      // 发票信息
      otherFields: [],
      otherRules: {
        title_type: [{ required: true, message: '请选择抬头类型', trigger: 'change' }]
      },
      otherFrom: {
        title_type: 1
      },

      // 邮寄信息
      mailFields: [],
      mailRules: {},
      mailFrom: {},
      // 审批信息
      examineInfo: {}
    };
  },

  computed: {
    editId: function editId() {
      return this.action.type == 'update' ? this.action.id : '';
    },
    title: function title() {
      return this.isEdit ? '编辑发票' : '新建发票';
    },
    isEdit: function isEdit() {
      return !!this.editId;
    },
    isOpenExamine: function isOpenExamine() {
      if (this.examineInfo) {
        // 初始状态是空对象默认展示，请求之后，根据status判断
        return _Object$keys(this.examineInfo).length > 0 ? this.examineInfo.examineStatus : true;
      }
      return false;
    },
    confirmButtonText: function confirmButtonText() {
      if (this.isOpenExamine) {
        return '提交审核';
      }
      return '保存';
    }
  },
  watch: {},
  created: function created() {
    this.getField();
    // if (this.detail && this.detail.customer_id) {
    //   this.fieldForm = {
    //     customer_id: [{
    //       name: this.detail.customerName,
    //       customer_id: this.detail.customer_id
    //     }],
    //     contract_id: this.detail.contract_id ? [{
    //       num: this.detail.contract_number,
    //       contract_id: this.detail.contract_id
    //     }] : []

    //   }
    // }
    // // 是编辑
    // if (this.detail) {
    //   const fieldForm = {}
    //   fieldForm.invoice_apple_number = this.detail.essential && this.detail.essential.invoice_apple_number
    //   fieldForm.customer_id = (this.detail.essential && this.detail.essential.customer_id) ? [{
    //     name: this.detail.essential.customer_name,
    //     customer_id: this.detail.essential.customer_id
    //   }] : []

    //   if (this.detail.essential && this.detail.essential.customer_id) {
    //     this.titleAction = {
    //       type: 'default',
    //       request: crmCustomerInvoiceInfoAPI,
    //       showScene: false,
    //       showSearch: false,
    //       showCreate: false,
    //       canShowDetail: true,
    //       params: {
    //         customer_id: this.detail.essential.customer_id
    //       }
    //     }
    //   } else if (this.detail.customer_id) {
    //     this.titleAction = {
    //       type: 'default',
    //       request: crmCustomerInvoiceInfoAPI,
    //       showScene: false,
    //       showSearch: false,
    //       showCreate: false,
    //       canShowDetail: true,
    //       params: {
    //         customer_id: this.detail.customer_id
    //       }
    //     }
    //   }
    //   if (this.detail.essential) {
    //     fieldForm.contract_id = this.detail.essential.contract_id ? [{
    //       num: this.detail.essential.contract_number,
    //       contract_id: this.detail.essential.contract_id
    //     }] : []

    //     fieldForm.contract_money = this.detail.essential.contract_money
    //     fieldForm.invoice_money = this.detail.essential.invoice_money
    //     fieldForm.invoice_date = this.detail.essential.invoice_date
    //     fieldForm.invoice_type = this.detail.essential.invoice_type
    //     fieldForm.remark = this.detail.essential.remark
    //     this.fieldForm = fieldForm
    //   }
    //   const otherFrom = {}
    //   if (this.detail.invoice) {
    //     otherFrom.title_type = this.detail.invoice.title_type
    //     otherFrom.invoice_title = this.detail.invoice.invoice_title
    //     otherFrom.tax_number = this.detail.invoice.tax_number
    //     otherFrom.deposit_bank = this.detail.invoice.deposit_bank
    //     otherFrom.deposit_account = this.detail.invoice.deposit_account
    //     otherFrom.deposit_address = this.detail.invoice.deposit_address
    //     otherFrom.phone = this.detail.invoice.phone
    //     this.otherFrom = otherFrom
    //   }
    //   const mailFrom = {}
    //   if (this.detail.posting) {
    //     mailFrom.contacts_name = this.detail.posting.contacts_name
    //     mailFrom.contacts_mobile = this.detail.posting.contacts_mobile
    //     mailFrom.contacts_address = this.detail.posting.contacts_address
    //     this.mailFrom = mailFrom
    //   }
    // }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    /**
     * 获取数据
     */
    getField: function getField() {
      var _this = this;

      this.loading = true;
      var params = {
        types: 'crm_invoice',
        module: 'crm',
        controller: 'invoice',
        action: this.action.type,
        format: 2
      };

      if (this.action.type == 'update') {
        params.action_id = this.action.id;
      }

      // if (this.action.type == 'update') {
      //   params.id = this.action.id
      // }

      filedGetFieldAPI(params).then(function (res) {
        var list = res.data || [];

        var assistIds = _this.getFormAssistIds(list);

        var baseFields = [];
        var fieldList = [];
        var fieldRules = {};
        var fieldForm = {};
        list.forEach(function (children) {
          var fields = [];
          children.forEach(function (item) {
            var temp = _this.getFormItemDefaultProperty(item);
            temp.show = !assistIds.includes(item.formAssistId);

            if (_this.ignoreFields.includes(temp.field)) {
              // 防止影响普通单选的验证方式
              delete temp.optionsData;
              delete item.optionsData;
            }

            var canEdit = _this.getItemIsCanEdit(item, _this.action.type);
            // 是否能编辑权限
            if (temp.show && canEdit) {
              // 自动生成编号
              if (item.autoGeneNumber == 1) {
                temp.placeholder = '根据编号规则自动生成，支持手动输入';
                var copyItem = objDeepCopy(item);
                copyItem.isNull = 0;
                fieldRules[temp.field] = _this.getRules(copyItem);
              } else {
                fieldRules[temp.field] = _this.getRules(item);
              }
            }

            // 是否可编辑
            temp.disabled = !canEdit;

            // 禁止某些业务组件选择
            if (temp.form_type == 'contract' || temp.form_type == 'customer') {
              if (_this.action.type === 'save') {
                temp.disabled = item.form_type === 'contract';
              } else if (_this.action.type == 'relative') {
                var customerObj = _this.action.data.customer;
                if (temp.form_type == 'customer') {
                  temp.disabled = !!customerObj;
                } else {
                  temp.disabled = !customerObj;
                }
              }
            }

            // 合同金额字段展示用
            if (temp.field === 'contract_money') {
              temp.disabled = true;
            }

            // 处理关联
            if (_this.action.type == 'update' || _this.action.type == 'relative') {
              if (item.form_type == 'contract') {
                // 合同 需要客户信息
                var customerItem = _this.getItemRelatveInfo(list, 'customer');
                if (customerItem) {
                  customerItem['moduleType'] = 'customer';
                  customerItem['params'] = { check_status: 2 };
                  temp['relation'] = customerItem;

                  _this.$set(_this.mailFrom, 'contacts_name', customerItem.contacts_name);
                  _this.$set(_this.mailFrom, 'contacts_mobile', customerItem.contacts_mobile);
                  _this.$set(_this.mailFrom, 'contacts_address', customerItem.contacts_address);

                  _this.titleAction = {
                    type: 'default',
                    request: crmCustomerInvoiceInfoAPI,
                    showScene: false,
                    showSearch: false,
                    showCreate: false,
                    canShowDetail: true,
                    params: {
                      customer_id: customerItem.customer_id
                    }
                  };
                }
              }
            }

            // 特殊字段允许多选
            _this.getItemRadio(item, temp);

            // 获取默认值
            if (temp.show) {
              if (_this.ignoreFields.includes(temp.field)) {
                fieldForm[temp.field] = _this.isEdit ? temp.value : temp.default_value;
              } else {
                fieldForm[temp.field] = _this.getItemValue(item, _this.action.data, _this.action.type);
              }
            }
            fields.push(temp);
            baseFields.push(item);
          });
          fieldList.push(fields);
        });

        _this.baseFields = baseFields;
        _this.fieldList = fieldList;
        _this.fieldForm = fieldForm;
        _this.fieldRules = fieldRules;

        // // 审核信息
        // this.initWkFlowData({
        //   params: { label: 3 },
        //   fieldForm: this.fieldForm
        // }, res => {
        //   this.wkFlowList = res.list
        //   this.flowRemarks = res.resData ? res.resData.remarks : ''
        // })

        // 获取其他块字段
        _this.getOtherField();
        // relative 下赋值联系人信息
        if (_this.isEdit || _this.action.type === 'relative') {
          var detail = _this.action.detail;
          var invoice = detail.invoice;
          var otherFrom = {};
          otherFrom.title_type = invoice.title_type;
          otherFrom.invoice_title = invoice.invoice_title;
          otherFrom.tax_number = invoice.tax_number;
          otherFrom.deposit_bank = invoice.deposit_bank;
          otherFrom.deposit_account = invoice.deposit_account;
          otherFrom.deposit_address = invoice.deposit_address;
          otherFrom.phone = invoice.phone;
          _this.otherFrom = otherFrom;
          var posting = detail.posting;
          var mailFrom = {};
          mailFrom.contacts_name = posting.contacts_name;
          mailFrom.contacts_mobile = posting.contacts_mobile;
          mailFrom.contacts_address = posting.contacts_address;
          _this.mailFrom = mailFrom;
        }
        _this.loading = false;
      }).catch(function (e) {
        _this.loading = false;
      });
    },
    getOtherField: function getOtherField() {
      this.otherFields = [{
        name: '抬头类型',
        field: 'title_type',
        form_type: 'select',
        setting: [{
          name: '单位',
          value: 1
        }, {
          name: '个人',
          value: 2
        }]
      }, {
        name: '开票抬头',
        field: 'invoice_title',
        form_type: 'text',
        setting: []
      }, {
        name: '纳税人识别号',
        field: 'tax_number',
        form_type: 'text',
        hidden: false,
        setting: []
      }, {
        name: '开户行',
        field: 'deposit_bank',
        form_type: 'text',
        hidden: false,
        setting: []
      }, {
        name: '开户账号',
        field: 'deposit_account',
        form_type: 'text',
        hidden: false,
        setting: []
      }, {
        name: '开票地址',
        field: 'deposit_address',
        form_type: 'text',
        hidden: false,
        setting: []
      }, {
        name: '电话',
        field: 'phone',
        form_type: 'text',
        setting: []
      }];

      this.mailFields = [{
        name: '联系人',
        field: 'contacts_name',
        form_type: 'text',
        setting: []
      }, {
        name: '联系方式',
        field: 'contacts_mobile',
        form_type: 'text',
        setting: []
      }, {
        name: '邮寄地址',
        field: 'contacts_address',
        form_type: 'text',
        setting: []
      }];
    },
    titleSelectChange: function titleSelectChange(data) {
      var dataValue = data.data;
      if (dataValue && dataValue.length) {
        var titleData = dataValue[0];
        for (var index = 0; index < this.otherFields.length; index++) {
          var element = this.otherFields[index];
          this.$set(this.otherFrom, element.field, titleData[element.field]);
        }

        var hidden = titleData.title_type == 2;
        this.otherFields[2].hidden = hidden;
        this.otherFields[3].hidden = hidden;
        this.otherFields[4].hidden = hidden;
        this.otherFields[5].hidden = hidden;
      }
    },


    // fieldValueChange(data) {
    //   const item = this.baseFields[data.index]
    //   const dataValue = data.value
    //   this.$set(this.fieldForm, item.field, dataValue)

    //   if (item.form_type == 'customer') {
    //     const contractItem = this.baseFields[data.index + 1]
    //     if (dataValue.length) {
    //       contractItem.disabled = false
    //       const customerItem = dataValue[0]
    //       customerItem['moduleType'] = 'customer'
    //       customerItem['params'] = { check_status: 2 }
    //       contractItem['relation'] = customerItem

    //       this.$set(this.mailFrom, 'contacts_name', customerItem.contacts_name)
    //       this.$set(this.mailFrom, 'contacts_mobile', customerItem.contacts_mobile)
    //       this.$set(this.mailFrom, 'contacts_address', customerItem.contacts_address)

    //       this.titleAction = {
    //         type: 'default',
    //         request: crmCustomerInvoiceInfoAPI,
    //         showScene: false,
    //         showSearch: false,
    //         showCreate: false,
    //         canShowDetail: true,
    //         params: {
    //           customer_id: customerItem.customer_id
    //         }
    //       }
    //     } else {
    //       contractItem.disabled = true
    //       contractItem['relation'] = {}
    //     }

    //     this.$set(this.fieldForm, 'contract_id', [])
    //     this.$set(this.fieldForm, 'invoice_money', '')
    //     this.$set(this.fieldForm, 'contract_money', '')
    //     this.$refs.crmForm.validateField(item.field)
    //   } else if (item.form_type == 'contract') {
    //     const contractValue = dataValue && dataValue.length ? dataValue[0] : null
    //     this.$set(this.fieldForm, 'contract_money', contractValue ? contractValue.money : '')
    //     this.$set(this.fieldForm, 'invoice_money', contractValue ? contractValue.money : '')
    //     this.$refs.crmForm.validateField(item.field)
    //   }
    // },

    otherFieldValueChange: function otherFieldValueChange(data) {
      var item = this.otherFields[data.index];
      var dataValue = data.value;
      if (item.field == 'title_type') {
        var hidden = dataValue == 2;
        this.otherFields[2].hidden = hidden;
        this.otherFields[3].hidden = hidden;
        this.otherFields[4].hidden = hidden;
        this.otherFields[5].hidden = hidden;
      }
      this.$set(this.otherFrom, item.field, dataValue);
    },
    mailFieldValueChange: function mailFieldValueChange(data) {
      var item = this.mailFields[data.index];
      var dataValue = data.value;
      this.$set(this.mailFrom, item.field, dataValue);
    },


    // 审批信息值更新
    examineValueChange: function examineValueChange(data) {
      this.examineInfo = data;
    },
    close: function close() {
      this.$emit('close');
    },
    saveClick: function saveClick() {
      var _this2 = this;

      this.$refs.crmForm.validate(function (valid) {
        if (valid) {
          // const params = {
          //   examineStatus: this.examineInfo.examineStatus
          // }
          var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
          // for (let index = 0; index < this.baseFields.length; index++) {
          //   const element = this.baseFields[index]
          //   if (!element.disabled) {
          //     if (element.form_type == 'customer') {
          //       const customerValue = this.fieldForm.customer_id && this.fieldForm.customer_id.length ? this.fieldForm.customer_id[0] : null
          //       params[element.field] = customerValue ? customerValue.customer_id : ''
          //     } else if (element.form_type == 'contract') {
          //       const contractValue = this.fieldForm.contract_id && this.fieldForm.contract_id.length ? this.fieldForm.contract_id[0] : null
          //       params[element.field] = contractValue ? contractValue.contract_id : ''
          //     } else {
          //       params[element.field] = this.fieldForm[element.field]
          //     }
          //   }
          // }

          for (var index = 0; index < _this2.otherFields.length; index++) {
            var element = _this2.otherFields[index];
            if (!element.disabled) {
              params[element.field] = _this2.otherFrom[element.field];
            }
          }

          for (var _index = 0; _index < _this2.mailFields.length; _index++) {
            var _element = _this2.mailFields[_index];
            if (!_element.disabled) {
              params[_element.field] = _this2.mailFrom[_element.field];
            }
          }

          if (_this2.isEdit) {
            params.invoice_id = _this2.action.id;
            // params.batchId = this.detail.batchId
          }

          _this2.getExamineValidateResult(function (result) {
            if (result) {
              if (_this2.examineInfo.config === 0) {
                params['check_user_id'] = _this2.examineInfo.value[0].id;
              }
              params['examineStatus'] = _this2.examineInfo.examineStatus;
              console.log(params);

              var request = _this2.isEdit ? crmInvoiceUpdateAPI : crmInvoiceSaveAPI;
              _this2.loading = true;
              request(params).then(function (res) {
                _this2.loading = false;
                _this2.close();
                // 回到保存成功
                _this2.$emit('save-success');
              }).catch(function () {
                _this2.loading = false;
              });
            }
          });
        }
      });
    },

    /**
     * 获取审批验证结果
     */
    getExamineValidateResult: function getExamineValidateResult(callBack) {
      if (this.isOpenExamine) {
        this.$refs.examineInfo.validateField(function (result) {
          callBack(result);
        });
      } else {
        callBack(true);
      }
    },

    /**
     * 验证唯一
     */
    UniquePromise: function UniquePromise(_ref) {
      var field = _ref.field,
          value = _ref.value;

      return this.getUniquePromise(field, value, this.action);
    },

    /**
     * change
     */
    formChange: function formChange(field, index, value, valueList) {
      // 审批流逻辑
      // this.debouncedGetWkFlowList(field.field, this.fieldForm)

      if (['select', 'checkbox'].includes(field.form_type) && field.remark === 'options_type' && field.optionsData) {
        var _getFormContentByOpti = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm),
            fieldForm = _getFormContentByOpti.fieldForm,
            fieldRules = _getFormContentByOpti.fieldRules;

        this.fieldForm = fieldForm;
        this.fieldRules = fieldRules;
      }
    },

    /**
     * 地址change
     */
    otherChange: function otherChange(data, field) {
      var _this3 = this;

      if (field.form_type === 'customer') {
        this.itemsForEach(this.fieldList, function (fieldItem) {
          if (fieldItem.form_type === 'contract') {
            // 如果是合同 改变合同样式和传入客户ID
            if (data.value.length > 0) {
              fieldItem.disabled = false;
              var customerItem = data.value[0];
              customerItem['moduleType'] = 'customer';
              customerItem['params'] = { check_status: 2 };
              fieldItem['relation'] = customerItem;

              _this3.$set(_this3.mailFrom, 'contacts_name', customerItem.contacts_name);
              _this3.$set(_this3.mailFrom, 'contacts_mobile', customerItem.contacts_mobile);
              _this3.$set(_this3.mailFrom, 'contacts_address', customerItem.contacts_address);

              _this3.titleAction = {
                type: 'default',
                request: crmCustomerInvoiceInfoAPI,
                showScene: false,
                showSearch: false,
                showCreate: false,
                canShowDetail: true,
                params: {
                  customer_id: customerItem.customer_id
                }
              };
            } else {
              fieldItem.disabled = true;
              fieldItem['relation'] = {};
              // 重置发票信息
              _this3.otherFields.forEach(function (item) {
                if (item.field !== 'title_type') {
                  _this3.otherFrom[item.field] = '';
                }
              });
            }
            _this3.fieldForm[fieldItem.field] = [];
          }
        });

        // this.$set(this.fieldForm, 'contract_id', [])
        this.$set(this.fieldForm, 'invoice_money', '');
        this.$set(this.fieldForm, 'contract_money', '');
        // this.debouncedGetWkFlowList('invoice_money', this.fieldForm)
      } else if (field.form_type === 'contract') {
        var contractValue = data.value && data.value.length ? data.value[0] : null;
        this.$set(this.fieldForm, 'contract_money', contractValue ? contractValue.money : '');
        this.$set(this.fieldForm, 'invoice_money', contractValue ? contractValue.money : '');
        // this.debouncedGetWkFlowList('invoice_money', this.fieldForm)
      }
      this.$set(this.fieldForm, field.field, data.value);
      this.$refs.crmForm.validateField(field.field);
    }
  }
};